import { render, staticRenderFns } from "./appSet.vue?vue&type=template&id=0bf891f3&scoped=true&"
import script from "./appSet.vue?vue&type=script&lang=js&"
export * from "./appSet.vue?vue&type=script&lang=js&"
import style0 from "./appSet.vue?vue&type=style&index=0&id=0bf891f3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf891f3",
  null
  
)

export default component.exports